"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _forown = _interopRequireDefault(require("./forown"));

// Object.assign polyfyll

/* istanbul ignore next */
var assign = Object.assign || function assign(target) {
  /* istanbul ignore next */
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  var output = Object(target);

  for (var index = 1; index < arguments.length; index++) {
    var source = arguments[index];

    if (source !== undefined && source !== null) {
      (0, _forown["default"])(source, function (nextValue, nextKey) {
        output[nextKey] = nextValue;
      });
    }
  }

  return output;
};

var _default = assign;
exports["default"] = _default;
//# sourceMappingURL=assign.js.map